import Homepage from './screens/Homepage';


function App () {
  return (
    <Homepage />
  );
}

export default App;
